import cx from "classnames";
import React, { CSSProperties } from "react";
import styles from "./fieldset-header.module.scss";

export interface IFieldsetHeader {
  children?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetHeader = (props: IFieldsetHeader) => {
  return (
    <div className={cx(styles.fieldset_header, props.className)} style={props.style} id={props.htmlId}>
      <div className={styles.title}>{props.children}</div>
      <div className={styles.actions}>{props.actions}</div>
    </div>
  );
};

FieldsetHeader.defaultProps = {};
